export default "__VITE_ASSET__46997099__"